import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=8d91cf3e&scoped=true"
import script from "./TabButton.vue?vue&type=script&lang=ts"
export * from "./TabButton.vue?vue&type=script&lang=ts"
import style0 from "./TabButton.vue?vue&type=style&index=0&id=8d91cf3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d91cf3e",
  null
  
)

export default component.exports